import { RouteRecordRaw } from 'vue-router';
import redirects from '@/redirects.yml';
import { redirectToExternalPage } from '@/utils/redirectToExternalPage';

// eslint-disable-next-line import/prefer-default-export
export function getStaticRedirects(): RouteRecordRaw[] {
  return Object.entries(redirects as Record<string, string>).map(([path, redirectUrl]) => {
    // Handle absolute urls, like https://learn.vonage.com/spotlight/
    if (!redirectUrl.startsWith('/')) {
      return {
        path,
        component: {},
        beforeEnter() {
          redirectToExternalPage(redirectUrl);
        },
      };
    }
    return { path, redirect: redirectUrl };
  });
}
